import script from "./ShowCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowCard.vue?vue&type=script&setup=true&lang=ts"

import "./ShowCard.vue?vue&type=style&index=0&id=aa0c758a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa0c758a"]])

export default __exports__